import { DemoRequestsList } from "./demoRequestsList";

export default {
	list: DemoRequestsList,
};
